<app-card-scroller *ngIf="details !== undefined" [header]="(('iaa.scientificArchiveFolder.scientificArchiveFolderDetails.numberFolder' | translate) + ': ' + details.folderLongId)">
    <div class="content-wrapper">
        <div class="details">
            <div class="section desktop-show">
                {{details.comments}}
            </div>
            <div class="section fixed-grid">
                <div class="item-container">
                    <div class="label">{{'iaa.general.expedition' | translate }}</div>
                    <div class="value ellipsis" [title]="(currentLanguage |async) === 'he' ? details.expedition?.expeditionName?.hebrew : details.expedition?.expeditionName?.english">
                    {{ (currentLanguage |async) === 'he' ? details.expedition?.expeditionName?.hebrew : details.expedition?.expeditionName?.english }}
                    </div>
                    </div>
                <div class="item-container">
                    <div class="label">{{ 'iaa.scientificArchiveFolder.scientificArchiveFolderDetails.boxId' | translate}}</div>
                    <div class="value">{{ details.boxId }}</div>
                </div>
                <div class="item-container">
                    <div class="label">{{ 'iaa.scientificArchiveFolder.scientificArchiveFolderDetails.status' | translate }}</div>
                    <div class="value">{{ details.status }}</div>
                </div>
            </div>
            <div class="section-accordion">
                <app-accordion-panel [header]="'iaa.scientificArchiveFolder.scientificArchiveFolderDetails.approvals' | translate " [count]="details.folderLicenseLongNames.length" [disabled]="details.folderLicenseLongNames.length === 0"
                [currentLanguage]="currentLanguage">
                    <div [ngClass]="{'accordion-row header fixed-grid-1':true, 'en': (currentLanguage |async)==='en'}">
                        <div class="accordion-col">{{ 'iaa.scientificArchiveFolder.scientificArchiveFolderDetails.folderRisBakIds' | translate   }}</div>
                    </div>
                    <div [ngClass]="{'accordion-row header fixed-grid-1':true, 'en': (currentLanguage |async)==='en'}"  *ngFor="let item of details.folderLicenseLongNames">
                        <div>
                            <bdi>{{item }}</bdi>
                        </div>
                    </div>
                </app-accordion-panel>
            </div>
            <div class="section-accordion">
                <app-accordion-panel [header]="'iaa.scientificArchiveFolder.scientificArchiveFolderDetails.additionalFolders' | translate " [count]="details.additionalFolders.length"
                    [disabled]="details.additionalFolders.length === 0"  [currentLanguage]="currentLanguage">
                    <div [ngClass]="{'accordion-row header fixed-grid-2': true, 'en':(currentLanguage |async)==='en'}">
                        <div class="accordion-col first">{{ 'iaa.scientificArchiveFolder.scientificArchiveFolderDetails.folderLongId' | translate  }}</div>
                        <div class="accordion-col">{{'iaa.general.title' | translate }}</div>
                    </div>
                    <div  [ngClass]="{'accordion-row header fixed-grid-2': true, 'en':(currentLanguage |async)==='en','current': details.folderLongId === item.folderLongId}"  *ngFor="let item of details.additionalFolders">
                        <div>
                            <a class="custom-link" role="navigation" tabindex="0" [appReturnFocus]="'folders:' + item.entityId" (click)="goToFolder(item.entityId);"
                                (keydown.enter)="goToFolder(item.entityId);">{{
                                item.folderLongId }}</a>
                                <span>{{item.folderLongId }}</span>

                        </div>
                        <div>{{ item.folderTitle }}</div>
                    </div>
                </app-accordion-panel>
            </div>
            <div class="section-keyword">
                <app-accordion-panel [header]="'iaa.scientificArchiveFolder.scientificArchiveFolderDetails.documents' | translate" [count]="details.documents.length"
                    [disabled]="details.documents.length === 0"  [currentLanguage]="currentLanguage">
                    <div [ngClass]="{'accordion-row header fixed-grid-2': true, 'en':(currentLanguage |async)==='en'}">
                        <div class="accordion-col">{{ 'iaa.scientificArchiveFolder.scientificArchiveFolderDetails.documentLongId' | translate  }}</div>
                        <div class="accordion-col">{{ 'iaa.scientificArchiveFolder.scientificArchiveFolderDetails.documentTitle' | translate  }}</div>
                    </div>
                    <div [ngClass]="{'accordion-row header fixed-grid-2': true, 'en':(currentLanguage |async)==='en'}" *ngFor="let item of details.documents">
                        <div>
                            <a class="custom-link" role="navigation" tabindex="0" [appReturnFocus]="'documents:' + item.entityId" (click)="goToDocument(item.entityId);"
                                (keydown.enter)="goToDocument(item.entityId);"> {{ item.documentLongId }}</a>
                        </div>
                        <div>{{ item.documentTitle }}</div>
                    </div>
                </app-accordion-panel>
            </div>
            <div style="flex-grow: 1;"></div>
        </div>
    </div>
</app-card-scroller>